export default __webpack_public_path__ + "static/media/profileAvatar.d8dc4137.png";